import Link from "next/link"
import React, { ComponentProps, useMemo } from "react"
import { twMerge } from "tailwind-merge"
import { buttonBasicStyles } from "./Button"
import { primaryButtonStyles } from "./PrimaryButton"
import { secondaryButtonStyles } from "./SecondaryButton"

type LinkAsButtonProps = ComponentProps<typeof Link>

const LinkAsButton: React.FC<
  LinkAsButtonProps & {
    text?: string
    type?: "primary" | "secondary"
    variant?: "small" | "regular"
  }
> = ({ text, type = "primary", className, children, variant = "regular", ...otherLinkProps }) => {
  const buttonClass = useMemo(() => {
    switch (type) {
      case "secondary":
        return secondaryButtonStyles
      default:
        return primaryButtonStyles
    }
  }, [type])
  const sizeStyles = variant === "small" ? "min-h-[48px] px-5" : "min-h-[52px] px-6"
  return (
    <Link className={twMerge([buttonBasicStyles, buttonClass, sizeStyles, className])} {...otherLinkProps}>
      {text ?? children}
    </Link>
  )
}

export default LinkAsButton
